import React from 'react';
import { useCurrentWidth } from 'ocfe/src/utilHooks/useCurrentWidth';
import sassVars from 'ocfe/styles/sass-variables.scss';

const MobileFabContent = React.lazy(() => import('./MobileFabContent'));

const MobileFab: React.FCC = () => {
    const { width } = useCurrentWidth();
    const isMobile = width < sassVars.tabletMaxWidth;

    return isMobile ? <MobileFabContent /> : null;
};

export default React.memo(MobileFab);
